export default () => ({
    textField: {
        marginTop: 13,
    },
    divider: {
        height: 20,
    },
});
